import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Tabs from 'wix-style-react/src/Tabs'

const TabTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const TabName = styled.div`
  margin-left: 8px
`

const CustomTabs = ({activeTab, tabsInfo, onClick}) => {
  const items = tabsInfo.map((tabInfo, index) => {
    const Icon = tabInfo.icon
    return {
      id: index,
      title: (
        <TabTitle>
          <Icon />
          <TabName>
            {tabInfo.name}
          </TabName>
        </TabTitle>
      )
    }
  })
  return (
    <Tabs
      activeId={activeTab}
      items={items}
      type='uniformFull'
      onClick={onClick}
    />
  )
}

CustomTabs.propTypes = {
  activeTab: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  tabsInfo: PropTypes.array.isRequired
}

export default CustomTabs



// WEBPACK FOOTER //
// ./src/components/editor/popovers/CustomTabs.js